import React from 'react'
import NotFound from '../notfound'

const NotFoundSv = () => {
    return <NotFound languageCode="sv" />
}

export default NotFoundSv
